import { IHeaderParams } from "ag-grid-community/dist/lib/headerRendering/cells/column/headerComp";
import { Box, Stack } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

/**
 * Component for Dashboard header column
 * @param {IHeaderParams<any>} param
 * @constructor
 */
const DashboardHeaderCol = (param: IHeaderParams<any>) => {
    if(!!param.column.getDefinition().headerTooltip){
        return (
            <Stack
                direction="row"
                textAlign="center"
                justifyContent="space-between"
                columnGap={1}
                alignItems="center"
                width="100%"
            >
                {param.displayName}
                <InfoOutlined fontSize="inherit" color="primary"/>
            </Stack>
        );
    } else {
        return(
            <Box sx={{textAlign: "center"}}>
                {param.displayName}
            </Box>
        )
    }
}

export default DashboardHeaderCol;
